<template>
    <div>
        <div class="row">
            <div class="col-12 mb-4 d-flex flex-row align-items-center justify-content-between">
                <h1>{{  $t('edit-group') }}</h1>
                <button type="button" class="btn btn-primary" @click="saveGroup">{{ $t('save') }}</button>
            </div>
            <div v-if="saved" class="col-12">
                <div class="alert alert-success">{{ $t('group-saved') }}</div>
            </div>
        </div>

        <div class="row flex-lg-row-reverse">
            <div class="col-12 col-lg-5 mb-4">
                <div v-if="!loading" class="list-group border-radius-2 no-border">
                    <div class="list-group-item">
                        <TextInput v-model="group.title" :label="$t('title')" class="mb-0" />
                    </div>
                    <div class="list-group-item">
                        {{ $t('programme') }}
                        <span class="font-weight-bold ml-2">{{ programme.Name }}</span>
                        
                    </div>
                    <div class="list-group-item">
                        {{ $t('year') }}
                        <span class="font-weight-bold ml-2">{{ group.year }}</span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-7 mb-4">
                <GroupStudentSelector v-model="group.students" :groupId="group.id" :groupTypeId="groupType.id" />
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from "src/components/Inputs/TextInput.vue"
import GroupStudentSelector from "src/components/GroupTypes/GroupStudentSelector.vue"

export default {
    components: {
        TextInput,
        GroupStudentSelector,
    },
    mounted() {
        this.$store.commit('showBlockingSpinner')
        Promise.all([this.fetchType(), this.fetchGroup()]).then(() => {
            this.loading = false
            this.$store.commit('hideBlockingSpinner')
        })
    },
    data() {
        return {
            loading: true,
            saved: false,
            submitting: false,
            group: {
                id:  Number(this.$route.params.groupId) ? Number(this.$route.params.groupId) : undefined,
                title: '',
                students: [],
            },
            groupType: {
                id: Number(this.$route.params.typeId) ? Number(this.$route.params.typeId) : undefined,
            },
            programme: null,
        }
    },
    methods: {
        fetchType() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/get`, {
                method: 'GET',
                data: {
                    id: this.$route.params.typeId
                },
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.groupType = res.result
                this.programme = this.$config.getValue('programmes')[this.groupType.programme_id]
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-group-type'),
                    confirmCallBack: () => {
                        this.$router.push('/settings/grouptypes')
                    }
                })
            })
        },
        fetchGroup() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/yeargroups/get`, {
                method: 'GET',
                data: { id: this.group.id }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.group = res.result
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-group'),
                    confirmCallBack: () => {
                        this.$router.push('/settings/grouptypes')
                    }
                })
            })
        },
        saveGroup() {
            if (this.submitting) return

            this.submitting = true
            this.saved = false
            this.$store.commit('showBlockingSpinner')

            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/yeargroups/save`, {
                method: 'POST',
                data: this.group,
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.saved = true
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-saving-group'),
                })
            }).finally(() => {
                this.submitting = false
                this.$store.commit('hideBlockingSpinner')
            })
        }
    },
}
</script>